import { render, staticRenderFns } from "./storeInHistList.vue?vue&type=template&id=6640f6b9&scoped=true"
import script from "./storeInHistList.vue?vue&type=script&lang=js"
export * from "./storeInHistList.vue?vue&type=script&lang=js"
import style0 from "./storeInHistList.vue?vue&type=style&index=0&id=6640f6b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6640f6b9",
  null
  
)

export default component.exports